import { compileAuthProxyHandler, proxyObjectWrapper, compileDefaultProxyHandler } from '../../utils/helpers/proxy-helpers';
import { apiClient } from './api-fetcher';

export const protectedContentApiClient = proxyObjectWrapper<typeof apiClient>(
  apiClient, compileAuthProxyHandler(process.env.REACT_APP_API_BASE || ''));

export const protectedTrackApiClient = proxyObjectWrapper<typeof apiClient>(
  apiClient, compileAuthProxyHandler(process.env.REACT_APP_TRACK_API_BASE || ''));

export const publicContentApiClient = proxyObjectWrapper<typeof apiClient>(
  apiClient, compileDefaultProxyHandler(process.env.REACT_APP_API_BASE || ''));
